export function getAlxPassSortKey(passName: string): number {
  const directionOffset = passName.endsWith('(CW)')
    ? 0.1
    : passName.endsWith('(CCW)')
      ? 0.2
      : 0

  const base = passName.replace(/\s*\((CW|CCW)\)\s*$/, '')

  if (base === 'ROOT') return 1 + directionOffset
  if (base === 'HOT') return 2 + directionOffset
  const fillMatch = /^Fill (\d+)$/.exec(base)
  if (fillMatch) return 3 + parseInt(fillMatch[1], 10) + directionOffset
  const capMatch = /^CAP (\d+)$/.exec(base)
  if (capMatch) return 1000 + parseInt(capMatch[1], 10) + directionOffset
  return 2000 + directionOffset
}

export function sortAlxPassRows<T extends { passName: string }>(rows: T[]): T[] {
  return [...rows].sort(
    (a, b) => getAlxPassSortKey(a.passName) - getAlxPassSortKey(b.passName)
  )
}

export function sortAlxPassLabels(labels: string[]): string[] {
  return [...labels].sort((a, b) => getAlxPassSortKey(a) - getAlxPassSortKey(b))
}
